export const SHIPPER_PARCELSHOP_SUFFIX = '_parcelshop';

export const SHIPPER_SHORTCUTS = {
  SPS: 'SPS',
  GLS: 'GLS',
  PACKETA: 'PACKETA',
  SK_123: '123',
  DPD: 'DPD',
  QDL: 'QDL',
  SKPOST: 'SK_POSTA',
  SDS: 'SDS',
};

export const SHIPPERS_WITH_WEIGHT = [SHIPPER_SHORTCUTS.DPD, SHIPPER_SHORTCUTS.SKPOST];
